// extracted by mini-css-extract-plugin
export var spinner = "Spinner-module--spinner--4EJns";
export var spinnerWrap = "Spinner-module--spinner-wrap--prSgb";